import { NoteEntity } from '../../../../coaching-base/config';
import { NoteCategory } from '../../../../coaching-base/general';
import { BehaviourItem } from '../../../../coaching-tags/models/behaviour.coaching.model';
import { SubBehaviourItem } from '../../../../coaching-tags/models/subbehaviour.coaching.model';
import { Chat } from '../../../../teams-call';
import { AllowedActions } from '../../../transcript-dialog/model/allowed-actions.model';
import { BehaviourTag } from '../../../transcript-dialog/model/behaviour-tag.model';
import { FilterOptions } from '../../../transcript-dialog/model/filter-options.model';
import { ChatBubble } from '../model/chat-bubble.model';

export interface TeamschatTranscriptDialogState {
    pending: {
        updateTranscript?: boolean;
    };
    behaviours?: BehaviourItem[];
    subBehaviours?: SubBehaviourItem[];
    defaultNoteCategory: NoteCategory;
    noteEntity?: NoteEntity;
    allowedActions?: AllowedActions;
    chat?: Chat;
    messages?: ChatBubble[];
    filteredQuotes?: ChatBubble[];
    filterOpts: FilterOptions;
    selectedQuotes?: ChatBubble[];
    filteredQuotesSelectedLookup: { [index: number]: boolean };
    allQuotesAreSelected?: boolean;
    focus?: BehaviourTag;
    cmtNotesFocus?: BehaviourTag;
    navigateCmtId?: number;
    navigateDraftId?: string;
    willNavigate: boolean;
}

export const defaultState = (): TeamschatTranscriptDialogState => ({
    pending: {},
    defaultNoteCategory: NoteCategory.GENERAL,
    filterOpts: {},
    filteredQuotesSelectedLookup: {},
    willNavigate: false,
    navigateCmtId: null,
    navigateDraftId: null,
    cmtNotesFocus: null,
});
